<template>
  <div v-if="group != null" id="list-group-translation">
    <v-row v-if="languages != null && languages.length > 0">
      <v-col cols="12">
        <v-card :loading="isLoading">
          <v-card-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="isGrantedUser()"
                  small
                  @click="openConfirmDialog = true"
                  v-on="on"
                  v-bind="attrs"
                  icon
                  :loading="loadingReset"
                >
                  <v-icon>mdi-restart</v-icon>
                </v-btn>
              </template>
              <span>Reset de la surcharge</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <v-tabs v-if="!isLoading">
              <v-tab
                v-for="lang in languages"
                :key="lang"
                :href="`#tab-${lang}`"
              >
                {{ lang }}
              </v-tab>

              <v-tab-item
                style="background-color: white"
                class="px-2"
                v-for="lang in languages"
                :key="lang"
                :value="'tab-' + lang"
              >
                <div
                  v-if="
                    group != null &&
                    group.portalConfigurationModel != null &&
                    group.portalConfigurationModel.languages != null &&
                    group.portalConfigurationModel.languages.includes(lang)
                  "
                  class="mt-3"
                >
                  <div
                    v-for="(item, key) in currentTranslation[lang]"
                    :key="key"
                  >
                    <div v-if="matchSearchTerm(key, lang)">
                      <v-text-field
                        :disabled="!isGrantedUser()"
                        :append-outer-icon="
                          isCurrentFieldUnsaved(lang, key)
                            ? 'mdi-content-save'
                            : ''
                        "
                        @click:append-outer="saveTranslation(lang, key)"
                        :loading="
                          isCurrentFieldUnsaved(lang, key) ||
                          currentTranslationBase[lang][key] !=
                            currentTranslation[lang][key]
                        "
                        outlined
                        :label="key"
                        v-model="currentTranslation[lang][key]"
                        @keypress="changeTranslation(lang, key)"
                        @input="changeTranslation(lang, key)"
                        persistent-hint
                        hint="Pas de surcharge"
                      >
                        <template v-slot:message>
                          <div
                            v-if="
                              currentTranslationBase[lang][key] !=
                              currentTranslation[lang][key]
                            "
                            class="font-weight-bold subtitle-2"
                          >
                            Valeur par défault :
                            {{ currentTranslationBase[lang][key] }}
                          </div>
                        </template>
                        <template v-slot:progress>
                          <v-progress-linear
                            v-if="isCurrentFieldUnsaved(lang, key)"
                            :value="100"
                            color="orange"
                            absolute
                            height="5"
                          ></v-progress-linear>
                          <v-progress-linear
                            v-else-if="
                              currentTranslationBase[lang][key] !=
                              currentTranslation[lang][key]
                            "
                            :value="100"
                            color="blue"
                            absolute
                            height="5"
                          ></v-progress-linear>
                        </template>
                      </v-text-field>

                      <v-divider class="mb-2"></v-divider>
                    </div>
                  </div>

                  <div v-if="!hasSearchResult">
                    Pas de résultat(s) trouvé pour la recherche.
                  </div>
                </div>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div v-else>
      <p>Pas de traduction possible pour ce modèle de portail.</p>
    </div>
  </div>
</template>
<script>
import { onMounted, toRefs, triggerRef, ref } from "@vue/composition-api";
import { useTranslation } from "@/composables/translation";
import router from "@/router";
import { useGroup } from "@/composables/group";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    languages: Array,
  },
  setup() {
    /* Import des API */
    const {
      updateGroupTranslation,
      getGroupTranslation,
      translationData,
      removeGroupTranslation,
      currentTranslationBase,
      currentTranslation,
      currentTranslationChanged,
      isCurrentFieldUnsaved,
      matchSearchTerm,
      changeTranslation,
    } = useTranslation();
    const { showGroup, currentGroup: group } = useGroup();

    /* Variables */
    const groupId = router.currentRoute.params.id;
    const loadingReset = ref(false);
    const { isGrantedUser } = useRoles();

    /* Cycle de vie */
    onMounted(async () => {
      translationData.isLoading = true;
      await showGroup(groupId);
      if (group.value.portalConfigurationModel.languages != null) {
        group.value.portalConfigurationModel.languages.forEach((lang) => {
          getGroupTranslation(groupId, lang);
        });
      }
    });

    /* Méthodes */
    const saveTranslation = (lang, key) => {
      console.log(key);
      currentTranslationChanged.value[lang] = {};
      triggerRef(currentTranslation);
      triggerRef(currentTranslationChanged);
      updateGroupTranslation(currentTranslation.value, groupId, lang);
    };

    return {
      matchSearchTerm,
      group,
      groupId,
      ...toRefs(translationData),
      updateGroupTranslation,
      removeGroupTranslation,
      currentTranslation,
      currentTranslationBase,
      changeTranslation,
      saveTranslation,
      currentTranslationChanged,
      isCurrentFieldUnsaved,
      loadingReset,
      isGrantedUser,
    };
  },
};
</script>
